import React from "react";
import type { PointerEvent as ReactPointerEvent } from "react";
import "./ColumnResizeBar.scss";

interface IProps {
    width: number;
    onResize?(width: number): void;
}
export default function ColumnResizeBar(props: IProps) {
    const onPointerDown = (e: ReactPointerEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();

        const initialX = e.clientX;
        const initialWidth = props.width;

        if (e.button === 0) {
            const onPointerMove = (event: PointerEvent) => {
                const width = initialWidth + event.clientX - initialX;

                if (props.onResize && width >= 72 && width <= 800) props.onResize(width);
            };

            const onPointerUp = () => {
                document.removeEventListener("pointermove", onPointerMove);
                document.removeEventListener("pointerup", onPointerUp);
            };

            document.addEventListener("pointermove", onPointerMove);
            document.addEventListener("pointerup", onPointerUp);
        }
    };
    return (
        <div
            className="userful-table-header-resize-bar"
            onPointerDown={onPointerDown}
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
            }}
        >
            <div className="userful-table-header-resize-bar-element"></div>
        </div>
    );
}
